<div id="content" class="allcp-form" ng-controller="OfferController" ng-init="all()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>

    <div class="navbar fixed-panel-footer" ng-if="deleted.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAll(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAll(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#"
                ng-click="delete('set')" 
                ng-disabled="deleted.length == 0" 
                ng-if="deleted.length > 0"
                class="btn btn-danger btn-rounded mr-3">Delete</a>
        </div>
    </div>

    <div class="panel-body">
        <div class="table-responsive" ng-if="data.offers.data.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th class="text-center w75"></th>
                        <th>Offer ID</th>
                        <th>Station</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Duration</th>
                        <th>Payout $/hr</th>
                        <th>Vehicle</th>
                        <th>Pcs</th>
                        <th>Application</th>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        dir-paginate="item in data.offers.data | itemsPerPage: 30" 
                        total-items="data.offers.total" 
                        current-page="data.offers.current_page">
                        <td class="text-center">
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.unique }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.station ? item.station.code : '-' }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.date | amDateFormat:'MM/DD/YYYY' }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.date + ' ' + item.start_time | amDateFormat:'hh:mm A' }} - {{ item.date + ' ' + item.end_time | amDateFormat:'hh:mm A' }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.start_time }} - {{ item.end_time }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">$ {{ item.price }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.wehicle }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.worker_count }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.application }}</td>
                    </tr>
                </tbody>
            </table>
            <dir-pagination-controls 
                boundary-links="true" 
                on-page-change="getPage(newPageNumber)" 
                template-url="dirPagination.tpl.html"
                class="pagination-lg pagination pull-right pr10">
            </dir-pagination-controls>
        </div>
        <div class="text-center mt50" ng-if="data.offers.data.length == 0">
            <img src="img/empty_page_orange.svg" alt="" width="400px">
            <br>
            <h3 style="font-size: 48px;font-weight: 800;">Offer not found</h3>
        </div>
    </div>
    <div ng-include="'modules/company/offers/show.html'"></div>
    <div ng-include="'modules/company/offers/new.html'"></div>
    <div ng-include="'modules/company/offers/new_worker.html'"></div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>